module.exports = __webpack_public_path__ + "c7c680afc7200de78a6cf4fc90244b15.pdf";